import type { StatusOption } from '../model';

export const STATUS: StatusOption[] = [
  {
    label: 'GENERIC_ACTIVE',
    value: 'Active',
  },
  {
    label: 'GENERIC_INACTIVE',
    value: 'Inactive',
  },
];
